export const STRING_UPPER_LOWER_SPECIAL_CHARACTERS_REGEX: RegExp = /[^0-9]/g;